export default __webpack_public_path__ + "static/concept-bd00b9b886c8def234b2d642605b63f2.webm";